// extracted by mini-css-extract-plugin
module.exports = {"swiper-box":"swiper_swiper-box__SEXje","banner-item":"swiper_banner-item__g0_vD","banner-item-bg":"swiper_banner-item-bg__FgFvO"};